/**
 * Health Fund Product Selector Module Bundle
 * @author Rhys Lloyd
 */

//
// Utilities
// Dependencies
import * as registry from '@core/registry';
import {COVER_SELECTOR_MODULE} from '@core/registry/names';
import module from './exec';

//
// Constants
import debug from "debug";
const MODULE_NAME = COVER_SELECTOR_MODULE;
const log = debug(MODULE_NAME);

//
// Register
if (!registry.exists(MODULE_NAME)) {
	registry.register(MODULE_NAME, registry.STATE.LOADING);
}

//
// Functions
export function exec () {
	module();
}

export {exec as default};
registry.setState(MODULE_NAME, registry.STATE.LOADED);

//
// Conditionally Self Execute
if (!registry.isRegistered(MODULE_NAME)) {
	exec();
	registry.setState(MODULE_NAME, registry.STATE.REGISTERED);
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/cover-selector/cover-selector.module.js